import type { MonetaryValue } from 'ezmoney';
import { gql } from 'graphql-tag';

export const GET_PAYABLE_LIST = gql`
  query Id6ccc14a442f829ab8e3869e3c7bde6ec(
    $companyId: ID!
    $cursor: ID
    $filtersV2: JSON
    $textualSearch: String
  ) {
    __typename
  }
`;

// FIXME: these types should be auto-generated from API schema and sync with the
// related GraphQl query

export type RawMember =
  | {
      __typename: 'User';
      id: string;
      givenName: string;
      familyName: string;
      email: string;
      avatar: string;
    }
  | {
      __typename: 'SuspendedUser';
      id: string;
      givenName: string;
      familyName: string;
    }
  | {
      __typename: 'Invitee';
      id: string;
      email: string;
    };

export type RawSupplier = {
  __typename: 'Supplier';
  id: string;
  name: string;
  thumbnailUrl?: string;
};

export type RawCounterparty = RawMember | RawSupplier;

export type RawMileageDetails = {
  distance: {
    value: number;
    unit: string;
  };
};

export type RawPerDiem = {
  tripDays: {
    stays: { arrivalTime: string | null; departureTime: string | null }[];
  }[];
};

export type RawPayableType =
  | 'single_purchase'
  | 'card_purchase'
  | 'subscription'
  | 'physical'
  | 'reversal'
  | 'expense_claim'
  | 'invoice_purchase'
  | 'mileage_allowance'
  | 'per_diem_allowance';

export type RawResult = {
  company: {
    payables: {
      totalCount: number;
      pageInfo: {
        hasNextPage: boolean;
      };
      edges: {
        cursor: string;
        node: {
          id: string;
          version: number;
          subtype: string | null;
          type: RawPayableType;
          kind: 'expense' | 'reversal';
          description: string;
          grossAmount: MonetaryValue;
          functionalAmount: MonetaryValue;
          counterparty?: RawCounterparty;
          member?: RawMember;
          supplier?: RawSupplier;
          documentaryEvidence:
            | {
                type: 'invoice' | 'declarationOfMissingInvoice';
                invoiceNumber: string | undefined;
              }
            | { type: 'creditNote'; creditNoteNumber: string | undefined }
            | undefined;
          creationDate: string;
          mileageDetails?: RawMileageDetails;
          perDiem?: RawPerDiem;
          costCenter?: { name: string } | null;
        };
      }[];
    };
  };
};
